import { render, staticRenderFns } from "./cImage.vue?vue&type=template&id=31790c1a&scoped=true"
import script from "./cImage.vue?vue&type=script&lang=js"
export * from "./cImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31790c1a",
  null
  
)

export default component.exports